// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ITOg1U62_RpbL1tsaPXA {
  display: flex;
  justify-content: space-between;
  padding: 0 20px !important;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.14);
  z-index: 99;
  height: 52px !important;
  line-height: 52px !important;
  background-color: #1A8D5F;
}
.bB38w3XR7g35dfzkn_J8 {
  background: #fff;
}
.bB38w3XR7g35dfzkn_J8 .IXP626_kvlrF2oBQ0dlG {
  width: 100%;
  height: calc(100% - 45px);
  border-radius: 5px;
}
.ImXKj8f7HRuJkhPv00jx {
  padding: 6px 6px 6px 20px;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/MainLayout/index.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,0BAAA;EACA,gDAAA;EACA,WAAA;EACA,uBAAA;EACA,4BAAA;EACA,yBAAA;AACF;AAEA;EACE,gBAAA;AAAF;AADA;EAII,WAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAIA;EACE,yBAAA;AAFF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 20px !important;\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.14);\n  z-index: 99;\n  height: 52px !important;\n  line-height: 52px !important;\n  background-color: #1A8D5F;\n}\n\n.content {\n  background: #fff;\n\n  .contentChildren {\n    width: 100%;\n    height: calc(100% - 45px);\n    border-radius: 5px;\n  }\n}\n\n.contentHeader {\n  padding: 6px 6px 6px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `ITOg1U62_RpbL1tsaPXA`,
	"content": `bB38w3XR7g35dfzkn_J8`,
	"contentChildren": `IXP626_kvlrF2oBQ0dlG`,
	"contentHeader": `ImXKj8f7HRuJkhPv00jx`
};
export default ___CSS_LOADER_EXPORT___;
